import React, { useEffect, useState, createContext, useContext } from 'react';
import { User, AuthContextType } from '../types';
const AuthContext = createContext<AuthContextType | undefined>(undefined);
// Mock users for demo - auto-login as customer
const MOCK_CUSTOMER: User = {
  id: '1',
  email: 'customer@example.com',
  name: 'John Smith',
  role: 'customer',
  phone: '(555) 123-4567',
  company: 'Smith Auto Body',
  billingAddress: {
    street: '123 Main Street',
    city: 'Austin',
    state: 'TX',
    zipCode: '78701',
    country: 'United States'
  }
};
const MOCK_ADMIN: User = {
  id: '2',
  email: 'admin@meremblasting.com',
  name: 'Sarah Johnson',
  role: 'admin',
  company: 'Merem Blasting',
  billingAddress: {
    street: '456 Industrial Blvd',
    city: 'Austin',
    state: 'TX',
    zipCode: '78702',
    country: 'United States'
  }
};
export function AuthProvider({
  children
}: {
  children: React.ReactNode;
}) {
  // Auto-login as customer on mount
  const [user, setUser] = useState<User | null>(MOCK_CUSTOMER);
  const [isLoading, setIsLoading] = useState(false);
  const login = async (email: string, password: string) => {
    // Mock login logic
    if (email.includes('admin')) {
      setUser(MOCK_ADMIN);
    } else {
      setUser(MOCK_CUSTOMER);
    }
  };
  const logout = () => {
    setUser(MOCK_CUSTOMER);
  };
  const updateUser = (updates: Partial<User>) => {
    if (user) {
      setUser({
        ...user,
        ...updates
      });
    }
  };
  return <AuthContext.Provider value={{
    user,
    login,
    logout,
    isLoading,
    updateUser
  }} data-id="element-181">
      {children}
    </AuthContext.Provider>;
}
export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
}